import {
  SHIFT_CREATOR_LIST_SEARCH,
  SHIFT_CREATOR_LIST_SEARCH_FAILURE,
  SHIFT_CREATOR_LIST_SEARCH_SUCCESS
} from './mutation-types'

export default {
  state: {
    shiftCreators: [],
    shiftCreatorListNextPage: null,
    shiftCreatorListCurrentPage: null
  },
  getters: {
    shiftCreators: state => {
      return state.shiftCreators
    },
    shiftCreatorListNextPage: state => {
      return state.shiftCreatorListNextPage
    },
    shiftCreatorListCurrentPage: state => {
      return state.shiftCreatorListCurrentPage
    }
  },
  actions: {
    [SHIFT_CREATOR_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/shift_creators'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHIFT_CREATOR_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHIFT_CREATOR_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHIFT_CREATOR_LIST_SEARCH_FAILURE] (state, params) {
      console.log('SHIFT_CREATOR_LIST_SEARCH_FAILURE')
    },
    [SHIFT_CREATOR_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('SHIFT_CREATOR_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.shiftCreators = state.shiftCreators.concat(data.data)
        state.shiftCreatorListCurrentPage = data.meta['current-page']
      } else {
        state.shiftCreators = data.data
        state.shiftCreatorListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.shiftCreatorListNextPage = data.links['next']
      } else {
        state.shiftCreatorListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-creator-list.js